import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { HeadAppenderService } from './headAppenderService'
import { ServiceProviderSymbol } from '@wix/thunderbolt-symbols'

export const site: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(HeadAppenderService)
}

export const editor = site
